import type { BadgeVariant } from '@/components/ui'
import type { BonusEntry, BonusEntryStatus, BonusType } from '@/features/bonuses/types/bonus.types'

export function bonusStatusBadgeVariant(status: BonusEntryStatus): BadgeVariant {
  switch (status) {
    case 'pending_approval':
      return 'warning'
    case 'approved':
      return 'success'
    case 'reversed':
      return 'neutral'
    default:
      return 'neutral'
  }
}

export function bonusStatusLabel(status: BonusEntryStatus): string {
  switch (status) {
    case 'pending_approval':
      return 'Pending approval'
    case 'approved':
      return 'Approved'
    case 'reversed':
      return 'Reversed'
    default:
      return status
  }
}

export function bonusTypeLabel(type: BonusType): string {
  switch (type) {
    case 'performance':
      return 'Performance'
    case 'attendance':
      return 'Attendance'
    case 'taxable':
      return 'Taxable'
    case 'non_taxable':
      return 'Non-taxable'
    default:
      return type
  }
}

const MONTH_NAMES = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

export function formatBonusPeriod(year: number, month: number): string {
  const name = MONTH_NAMES[month - 1] ?? `Month ${month}`
  return `${name} ${year}`
}

/**
 * Human label for the employee a bonus belongs to: "Name (EMP-023)", the name
 * or code alone, or an em dash. The raw user id is never shown as a label.
 */
export function bonusEmployeeLabel(entry: Pick<BonusEntry, 'employeeName' | 'employeeId'>): string {
  const name = entry.employeeName?.trim()
  const code = entry.employeeId?.trim()
  if (name && code) return `${name} (${code})`
  return name || code || '—'
}
